import axios from 'axios'

export default axios.create({
    baseURL: 'https://webservice.faroit.com.br/APIRest/whatsapp/v1',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer 1a805caa419c45a3072ce8c9b3262ae4739d4795a94deb6f1d275f1933eaab41', 
    },
});
